<template>
  <aside class="main-sidebar elevation-4" :class="this.$store.getters['ui/sidebarSkin']">
    <router-link to="/" class="brand-link" style="height: 3rem">
      <span class="brand-text font-weight-light">{{ appTitle }}</span>
    </router-link>

    <div class="brand-link" style="height: 10rem">
      <div class="pl-2 pr-2">
        <dl class="" style="font-size: 1rem">
          <dt class="col-sm-12"><i class="fas fa-server"></i><span class="brand-text">&nbsp;Server time:</span></dt>
          <dd class="col-sm-12 brand-text">{{serverTime}} <b-button size="xsm" variant="outline-secondary" @click="copyToClipboard(serverTime)"><i class="fas fa-copy"></i></b-button></dd>
          <dt class="col-sm-12 "><i class="fas fa-globe"></i><span class="brand-text">&nbsp;Local time:</span></dt>
          <dd class="col-sm-12 brand-text">{{localTime}} <b-button size="xsm" variant="outline-secondary" @click="copyToClipboard(localTime)"><i class="fas fa-copy"></i></b-button></dd>
        </dl>
      </div>
    </div>
    <div class="sidebar" style="height: calc(100vh - (14rem + 01px))">
      <nav class="mt-2">
        <ul
            class="nav nav-pills nav-sidebar flex-column nav-compact nav-child-indent"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
        >
          <app-menu-item
              v-for="item in menu"
              :menuItem="item"
              v-bind:key="item.name"
          ></app-menu-item>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import MenuItem from '../../../components/menu-item/menu-item.vue';
import * as moment from "moment";
import 'moment-timezone';
import * as Roles from "../../../definitions/Roles";
import {menuItems} from "./menu-items";

const copyToClipboard = str => {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText)
    return navigator.clipboard.writeText(str);
  return Promise.reject('The Clipboard API is not available.');
};

export default {
  name: 'app-menu-sidebar',
  components: {
    'app-menu-item': MenuItem
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_DOCUMENT_TITLE,
      serverTime: null,
      localTime: null,
    }
  },
  computed: {
    menu() {
      const currentUser = this.$store.getters['currentUser'];

      let children = menuItems

      if (!currentUser) {
        return children = [];
      } else {
        children = children.filter(({roles = [], path}) => {
          if (currentUser.type === Roles.ADMIN) {
            return true;
          }

          if (roles.includes(currentUser.type)) {
            return true;
          }

          if (currentUser.allowedPages === null) {
            return true;
          }

          return currentUser.allowedPages.includes(path);
        })
      }

      return children;
    },
  },
  methods: {
    copyToClipboard(time) {
      let info = {
        name: 'copyToClipboard',
        msg: 'Copied to clipboard: <br>' + time,
        type: "info",
        preventDuplicates: true,
        timeout: 1000,
      };
      this.$toastr.removeByName('copyToClipboard');

      copyToClipboard(time)
          .then(() => {
            this.$toastr.Add(info);
          })
          .catch((err) => {
            this.$toastr.e(err);
          });
    },
    updateTime() {
      this.serverTime = moment().tz('UTC').format('YYYY-MM-DD HH:mm:ss');
      this.localTime = moment().format('YYYY-MM-DD HH:mm:ss');
    },
  },
  mounted() {
    this.$store.dispatch('loadCurrentUser');
    this.updateTime();
    setInterval(this.updateTime, 1000);
  }
}

</script>
<style></style>
